import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { IFBSubscription } from '@app/models/payment';

@Injectable({
  providedIn: 'root'
})
export class PaymentResource {
  constructor(private http: HttpClient) {}

  private url(companyId: string): string {
    // This service cannon inject CompanyService, it'll cause circular dependency
    return `https://${environment.API_BASE}/v1/companies/${companyId}/payment`;
  }

  public getPlanSubscription(companyId: string) {
    const url = `${this.url(companyId)}/subscription`;
    return this.http.get<IFBSubscription>(url);
  }
}
